const dateTimeFormatter = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZone: "America/Los_Angeles"
});

const dateFormatter = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric",
  timeZone: "America/Los_Angeles"
});

function format(formatter, value) {
  if (!value) return "—";
  // Anchor "YYYY-MM-DD" (DateOnly) as local midnight; otherwise JS parses it
  // as UTC midnight, which renders as the previous day west of UTC.
  const input = typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value;
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "—";
  return formatter.format(d);
}

export const fmtDateTime = (value) => format(dateTimeFormatter, value);
export const fmtDate = (value) => format(dateFormatter, value);
